// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".loverly-inspiration-item[data-v-3489e23c] .main-image-hover{border-radius:.375rem!important}.loverly-inspiration-item.mini .title[data-v-3489e23c]{font-size:.9375rem}.loverly-inspiration-item.mini .photographer[data-v-3489e23c]{display:none}.bottom-inset-shadow[data-v-3489e23c]{box-shadow:inset 0 -56px 40px -10px rgba(0,0,0,.5)}.photographer i.icon[data-v-3489e23c]{margin-bottom:2px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
